// extracted by mini-css-extract-plugin
module.exports = {"value-input":"Input_value-input__wCaIC"};